import { DesktopGridItem } from 'shared/types/desktop-grid'

export type AutoArrangeHandler = (
  items: DesktopGridItem[],
  cols: number,
  rows: number
) => DesktopGridItem[]
